import {
  BaseQueryApi,
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { loginRequest } from '../authConfig/AuthConfig'
import { msalInstance } from '..'
import { Mutex } from 'async-mutex'
import { handleFireFighterReauth } from '../utils/helper/firefighterReauth'
import { handleMsalReauth } from '../utils/helper/msalReauth'

export const mutex = new Mutex()
const getEndpoint = () => {
  return 'controlplane/api'
}
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL + getEndpoint(),
  prepareHeaders: (headers, { getState }) => {
    const state: any = getState()
    const token = state.atlas.accessToken
    headers.set('Authorization', `Bearer ${token}`)
    return headers
  },
})

const baseQueryWithReauth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: NonNullable<unknown>,
) => {
  await mutex.waitForUnlock()
  let result: any = await baseQuery(args, api, extraOptions)
  if (result?.error?.status === 401 || result?.status === 401) {
    console.log('Session Expired Reauthenticating now', mutex.isLocked())
    if (!mutex.isLocked()) {
      const release = await mutex.acquire()
      const isFireFighterAccessEnabled = (api.getState() as any).atlas
        .isFireFighterAccessEnabled
      try {
        if (isFireFighterAccessEnabled === true) {
          return await handleFireFighterReauth(
            api,
            args,
            extraOptions,
            baseQuery,
            result,
          )
        }

        return await handleMsalReauth(
          api,
          args,
          extraOptions,
          baseQuery,
          result,
        )
      } catch (error) {
        if (isFireFighterAccessEnabled !== true) {
          msalInstance.loginRedirect(loginRequest).catch((e) => {
            console.error('loginRedirect failed:', e)
          })
        }
      } finally {
        release()
      }
    } else {
      await mutex.waitForUnlock()
      result = await baseQuery(args, api, extraOptions)
    }
  }

  return result
}
export const apiService = createApi({
  reducerPath: 'apiService',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'VendorList',
    'GetVendorByCode',
    'TenantList',
    'TenantDetailsByCode',
    'HaulerList',
    'GetHaulerByCode',
    'TenantAdminList',
    'TenantAdminDetails',
    'CustomerList',
    'GetCustomerByCode',
    'PlantList',
    'GetPlantByCode',
    'AssociatedVendorList',
    'ProductList',
    'DashboardList',
    'GeolocationList',
    'UnmappedProductList',
    'MasterProductList',
    'GetMasterProductByCode',
    'HaulerAdminList',
    'GetRoles',
    'GetRoleCapabilities',
    'GetUsers',
    'GetAppTypesWithRoles',
    'GetDomainName',
    'GetAppCapabilities',
    'GetApprovedCustomers',
    'GetUserDetailsById',
    'GetMasterRoles',
    'GetUserLogActivity',
    'GetRoleActivity',
  ],
  endpoints: () => ({}),
})
